export default __webpack_public_path__ + "static/media/scrollRight4.9166d92b.jpg";